export async function revalidate(tags: string[] | string): Promise<unknown> {
  const tagString: string = Array.isArray(tags) ? tags.join(',') : tags;

  const CUSTOMER_BASE_URL: string = import.meta.env.VITE_APP_CUSTOMER_URI as string;

  const url = `${CUSTOMER_BASE_URL}/api/revalidate?tag=${tagString}`;

  try {
    const response = await fetch(url);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data: unknown = await response.json();
    return data;
  } catch {
    return null;
  }
}
